export let version = "v2.5.129.136";
export let Stockversion = "v2.5.127.128.431";



// WEBPACK FOOTER //
// ./src/providers/version.ts